module.exports = __webpack_public_path__ + "static/fonts/FontAwesome.0d2717c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FontAwesome.otf
// module id = cL3u
// module chunks = 0